import React from 'react';
import ProjectList from '../ProjectList';
import About from '../About';
import Contact from '../Contact'

function Main (){
    return (
        <main>
            <About />
            <ProjectList />
            <Contact />
        </main>
    )
}

export default Main;